import { useState } from 'react';
import type { Flashcard } from '@/types/educate';

export function FlashCard({ term, definition }: Flashcard) {
  const [flipped, setFlipped] = useState(false);

  return (
    <button
      type="button"
      onClick={() => setFlipped((value) => !value)}
      aria-pressed={flipped}
      data-testid="flashcard"
      className="group h-52 w-full text-left [perspective:1200px]"
    >
      <div
        className={`relative h-full w-full rounded-xl shadow-sm transition-transform duration-500 [transform-style:preserve-3d] ${
          flipped ? '[transform:rotateY(180deg)]' : ''
        }`}
      >
        <div className="absolute inset-0 flex flex-col rounded-xl bg-brand-700 p-4 [backface-visibility:hidden]">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-white/55">
            Click to flip
          </span>
          <span className="mt-auto text-lg font-bold uppercase tracking-wide text-white">
            {term}
          </span>
        </div>

        <div className="absolute inset-0 flex flex-col overflow-hidden rounded-xl border border-brand-200 bg-white p-4 [backface-visibility:hidden] [transform:rotateY(180deg)]">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-500">
            {term}
          </span>
          <span className="thin-scrollbar mt-1.5 min-h-0 flex-1 overflow-y-auto pr-2 text-base leading-snug text-slate-700">
            {definition}
          </span>
        </div>
      </div>
    </button>
  );
}
